// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activities-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 0;
  position: relative;
}
.activities-header .search-container {
  flex: 1 1;
  min-width: 300px;
  max-width: 400px;
}
.activities-header .actions-container {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.activities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding: 0;
}

.activity-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 8px);
  padding: 20px;
  box-shadow: var(--m-box-shadow-car, 0 2px 4px rgba(0, 0, 0, 0.1));
  transition: all 0.2s ease;
  cursor: pointer;
}
.activity-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  border-color: var(--m-primary, #007bff);
}
.activity-card__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--m-subtle, #f0f0f0);
}
.activity-card__avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary, #007bff);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.activity-card__title {
  flex: 1 1;
  min-width: 0;
}
.activity-card__title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--m-text, #333);
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.activity-card__title p {
  margin: 0;
  font-size: 13px;
  color: var(--m-text-light, #666);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.activity-card__badge {
  background: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary, #007bff);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.activity-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}
.activity-card__info-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: var(--m-text, #333);
}
.activity-card__info-item svg {
  color: var(--m-text-light, #999);
  margin-top: 2px;
  flex-shrink: 0;
}
.activity-card__info-item span {
  flex: 1 1;
  line-height: 1.5;
}
.activity-card__info-item span strong {
  font-weight: 600;
  color: var(--m-text, #333);
}
.activity-card__footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--m-subtle, #f0f0f0);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding: 16px;
  border-top: 1px solid var(--m-subtle, #e0e0e0);
  flex-wrap: wrap;
}
.pagination-container .pagination-info {
  font-size: 14px;
  color: var(--m-text-light, #666);
  display: flex;
  align-items: center;
}
.pagination-container nav {
  display: flex;
  align-items: center;
}
.pagination-container .pagination {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 4px;
  align-items: center;
}
.pagination-container .pagination .page-item {
  display: flex;
  align-items: center;
}
.pagination-container .pagination .page-item.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.pagination-container .pagination .page-item.active .page-link {
  background-color: var(--m-primary, #007bff);
  color: var(--m-white, #fff);
  border-color: var(--m-primary, #007bff);
}
.pagination-container .pagination .page-item .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius, 4px);
  background-color: var(--m-card-background-color, #fff);
  color: var(--m-text, #333);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}
.pagination-container .pagination .page-item .page-link:hover:not(:disabled) {
  background-color: var(--m-subtle, #f0f0f0);
  border-color: var(--m-primary, #007bff);
  color: var(--m-primary, #007bff);
}
.pagination-container .pagination .page-item .page-link:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.pagination-container .pagination .page-item .page-link span {
  font-size: 18px;
  line-height: 1;
}

.entity-info-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 8px);
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: var(--m-box-shadow-car, 0 2px 4px rgba(0, 0, 0, 0.1));
}
.entity-info-card__header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.entity-info-card__avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary, #007bff);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.entity-info-card__content {
  flex: 1 1;
}
.entity-info-card__content h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--m-text, #333);
}
.entity-info-card__content p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--m-text-light, #666);
}
.entity-info-card__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.entity-count-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--m-background-subtle-primary, #e3f2fd);
  border: 1px solid var(--m-primary-subtle, rgba(0, 123, 255, 0.2));
  color: var(--m-primary, #007bff);
  white-space: nowrap;
}
.entity-count-pill__label {
  font-size: 12px;
  font-weight: 600;
  color: var(--m-text-light, #666);
}
.entity-count-pill__value {
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  background: rgba(0, 123, 255, 0.12);
  color: var(--m-primary, #007bff);
}

.activities-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
@media (max-width: 1024px) {
  .activities-list {
    grid-template-columns: 1fr;
  }
}

.activity-item-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 8px);
  padding: 20px;
  box-shadow: var(--m-box-shadow-car, 0 2px 4px rgba(0, 0, 0, 0.1));
  transition: all 0.2s ease;
}
.activity-item-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: var(--m-primary, #007bff);
}
.activity-item-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--m-subtle, #f0f0f0);
}
.activity-item-card__timestamp {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--m-text-light, #666);
}
.activity-item-card__timestamp svg {
  color: var(--m-text-light, #999);
}
.activity-item-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.activity-item-card__info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.activity-item-card__label {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 100px;
  font-size: 14px;
  font-weight: 500;
  color: var(--m-text, #333);
}
.activity-item-card__label svg {
  color: var(--m-text-light, #999);
  flex-shrink: 0;
}
.activity-item-card__value {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--m-text, #333);
}
.activity-item-card__value strong {
  font-weight: 600;
  display: block;
}
.activity-item-card__value small {
  display: block;
  font-size: 12px;
  color: var(--m-text-light, #666);
  margin-top: 2px;
}

.activity-link-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--m-primary, #007bff);
  cursor: pointer;
  margin-left: 8px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.activity-link-icon:hover {
  background-color: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary-bolder, #0056b3);
}
.activity-link-icon:active {
  transform: scale(0.95);
}

.drill-list {
  margin-top: 1rem;
}
.drill-list__title {
  margin-bottom: 1rem;
  font-size: 1rem;
  color: var(--m-text, #333);
}
.drill-list__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}
.drill-list__card {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.2s;
  padding: 12px 14px;
}
.drill-list__card:hover {
  background: var(--m-background-subtle-primary-hovered, #f5f5f5);
}
.drill-list__right {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 999px;
  background: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary, #007bff);
}
.drill-list__count {
  font-size: 13px;
  line-height: 1;
  padding: 2px 8px;
  border-radius: 999px;
}
.drill-list__arrow {
  margin-left: 0;
  color: currentColor;
  flex-shrink: 0;
}

.ml-2 {
  margin-left: 8px;
}

.d-block {
  display: block;
}

@media (max-width: 768px) {
  .activities-header {
    flex-direction: column;
    align-items: stretch;
  }
  .activities-header .search-container {
    max-width: none;
    min-width: 0;
  }
  .activities-header .actions-container {
    width: 100%;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Activities/Activities.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AACF;AACE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAIA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,UAAA;AADF;;AAIA;EACE,gDAAA;EACA,oDAAA;EACA,6CAAA;EACA,aAAA;EACA,iEAAA;EACA,yBAAA;EACA,eAAA;AADF;AAGE;EACE,0CAAA;EACA,2BAAA;EACA,uCAAA;AADJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uDAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAHJ;AAME;EACE,SAAA;EACA,YAAA;AAJJ;AAMI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJN;AAOI;EACE,SAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALN;AASE;EACE,uDAAA;EACA,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AARJ;AAWE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;AATJ;AAWI;EACE,gCAAA;EACA,eAAA;EACA,cAAA;AATN;AAYI;EACE,SAAA;EACA,gBAAA;AAVN;AAYM;EACE,gBAAA;EACA,0BAAA;AAVR;AAeE;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,8CAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAdF;AAgBE;EACE,kCAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,eAAA;AAfJ;;AAmBA;EACE;IACE,uBAAA;EAhBF;EAkBA;IACE,yBAAA;EAhBF;AACF;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,eAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,8CAAA;EACA,eAAA;AAlBF;AAoBE;EACE,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,aAAA;EACA,mBAAA;AApBN;AAsBM;EACE,YAAA;EACA,oBAAA;AApBR;AAwBQ;EACE,2CAAA;EACA,2BAAA;EACA,uCAAA;AAtBV;AA0BM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,oDAAA;EACA,0CAAA;EACA,sDAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AAxBR;AA0BQ;EACE,0CAAA;EACA,uCAAA;EACA,gCAAA;AAxBV;AA2BQ;EACE,mBAAA;EACA,YAAA;AAzBV;AA4BQ;EACE,eAAA;EACA,cAAA;AA1BV;;AAiCA;EACE,gDAAA;EACA,oDAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,iEAAA;AA9BF;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9BJ;AAiCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uDAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,SAAA;AAhCJ;AAkCI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAhCN;AAmCI;EACE,aAAA;EACA,eAAA;EACA,gCAAA;AAjCN;AAqCE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAnCJ;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,uDAAA;EACA,iEAAA;EACA,gCAAA;EACA,mBAAA;AApCF;AAsCE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AApCJ;AAuCE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,gCAAA;AArCJ;;AAyCA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAtCF;AAwCE;EALF;IAMI,0BAAA;EArCF;AACF;;AAwCA;EACE,gDAAA;EACA,oDAAA;EACA,6CAAA;EACA,aAAA;EACA,iEAAA;EACA,yBAAA;AArCF;AAuCE;EACE,0CAAA;EACA,uCAAA;AArCJ;AAwCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAtCJ;AAyCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;AAvCJ;AAyCI;EACE,gCAAA;AAvCN;AA2CE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AA1CJ;AA6CE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AA3CJ;AA6CI;EACE,gCAAA;EACA,cAAA;AA3CN;AA+CE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;AA7CJ;AA+CI;EACE,gBAAA;EACA,cAAA;AA7CN;AAgDI;EACE,cAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;AA9CN;;AAmDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAhDF;AAkDE;EACE,6DAAA;EACA,uCAAA;AAhDJ;AAmDE;EACE,sBAAA;AAjDJ;;AAqDA;EACE,gBAAA;AAlDF;AAoDE;EACE,mBAAA;EACA,eAAA;EACA,0BAAA;AAlDJ;AAqDE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AApDJ;AAsDI;EACE,+DAAA;AApDN;AAwDE;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,uDAAA;EACA,gCAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AAvDJ;AA0DE;EACE,cAAA;EACA,mBAAA;EACA,cAAA;AAxDJ;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE;IACE,sBAAA;IACA,oBAAA;EAzDF;EA2DE;IACE,eAAA;IACA,YAAA;EAzDJ;EA4DE;IACE,WAAA;IACA,8BAAA;EA1DJ;AACF","sourcesContent":[".activities-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 0;\n  position: relative;\n\n  .search-container {\n    flex: 1;\n    min-width: 300px;\n    max-width: 400px;\n  }\n\n  .actions-container {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n}\n\n.activities-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  padding: 0;\n}\n\n.activity-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 8px);\n  padding: 20px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 4px rgba(0, 0, 0, 0.1));\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    transform: translateY(-2px);\n    border-color: var(--m-primary, #007bff);\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid var(--m-subtle, #f0f0f0);\n  }\n\n  &__avatar {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: var(--m-background-subtle-primary, #e3f2fd);\n    color: var(--m-primary, #007bff);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  &__title {\n    flex: 1;\n    min-width: 0;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n      margin-bottom: 4px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    p {\n      margin: 0;\n      font-size: 13px;\n      color: var(--m-text-light, #666);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  &__badge {\n    background: var(--m-background-subtle-primary, #e3f2fd);\n    color: var(--m-primary, #007bff);\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n\n  &__info-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    font-size: 14px;\n    color: var(--m-text, #333);\n\n    svg {\n      color: var(--m-text-light, #999);\n      margin-top: 2px;\n      flex-shrink: 0;\n    }\n\n    span {\n      flex: 1;\n      line-height: 1.5;\n\n      strong {\n        font-weight: 600;\n        color: var(--m-text, #333);\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 16px;\n    border-top: 1px solid var(--m-subtle, #f0f0f0);\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n.pagination-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-top: 24px;\n  padding: 16px;\n  border-top: 1px solid var(--m-subtle, #e0e0e0);\n  flex-wrap: wrap;\n\n  .pagination-info {\n    font-size: 14px;\n    color: var(--m-text-light, #666);\n    display: flex;\n    align-items: center;\n  }\n\n  nav {\n    display: flex;\n    align-items: center;\n  }\n\n  .pagination {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    gap: 4px;\n    align-items: center;\n\n    .page-item {\n      display: flex;\n      align-items: center;\n\n      &.disabled {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n\n      &.active {\n        .page-link {\n          background-color: var(--m-primary, #007bff);\n          color: var(--m-white, #fff);\n          border-color: var(--m-primary, #007bff);\n        }\n      }\n\n      .page-link {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 36px;\n        height: 36px;\n        padding: 0 12px;\n        border: 1px solid var(--m-border-card-file, #e0e0e0);\n        border-radius: var(--m-border-radius, 4px);\n        background-color: var(--m-card-background-color, #fff);\n        color: var(--m-text, #333);\n        font-size: 14px;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        text-decoration: none;\n\n        &:hover:not(:disabled) {\n          background-color: var(--m-subtle, #f0f0f0);\n          border-color: var(--m-primary, #007bff);\n          color: var(--m-primary, #007bff);\n        }\n\n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.5;\n        }\n\n        span {\n          font-size: 18px;\n          line-height: 1;\n        }\n      }\n    }\n  }\n}\n\n.entity-info-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 8px);\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 4px rgba(0, 0, 0, 0.1));\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  &__avatar {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: var(--m-background-subtle-primary, #e3f2fd);\n    color: var(--m-primary, #007bff);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    flex: 1;\n\n    h3 {\n      margin: 0 0 8px 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n    }\n\n    p {\n      margin: 4px 0;\n      font-size: 14px;\n      color: var(--m-text-light, #666);\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n}\n\n.entity-count-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: var(--m-background-subtle-primary, #e3f2fd);\n  border: 1px solid var(--m-primary-subtle, rgba(0, 123, 255, 0.2));\n  color: var(--m-primary, #007bff);\n  white-space: nowrap;\n\n  &__label {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--m-text-light, #666);\n  }\n\n  &__value {\n    min-width: 22px;\n    height: 22px;\n    padding: 0 8px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 700;\n    background: rgba(0, 123, 255, 0.12);\n    color: var(--m-primary, #007bff);\n  }\n}\n\n.activities-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.activity-item-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 8px);\n  padding: 20px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 4px rgba(0, 0, 0, 0.1));\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    border-color: var(--m-primary, #007bff);\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid var(--m-subtle, #f0f0f0);\n  }\n\n  &__timestamp {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: var(--m-text-light, #666);\n\n    svg {\n      color: var(--m-text-light, #999);\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__info-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  &__label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 100px;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--m-text, #333);\n\n    svg {\n      color: var(--m-text-light, #999);\n      flex-shrink: 0;\n    }\n  }\n\n  &__value {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: var(--m-text, #333);\n\n    strong {\n      font-weight: 600;\n      display: block;\n    }\n\n    small {\n      display: block;\n      font-size: 12px;\n      color: var(--m-text-light, #666);\n      margin-top: 2px;\n    }\n  }\n}\n\n.activity-link-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--m-primary, #007bff);\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: var(--m-background-subtle-primary, #e3f2fd);\n    color: var(--m-primary-bolder, #0056b3);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.drill-list {\n  margin-top: 1rem;\n\n  &__title {\n    margin-bottom: 1rem;\n    font-size: 1rem;\n    color: var(--m-text, #333);\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 12px;\n  }\n\n  &__card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n    transition: background 0.2s;\n    padding: 12px 14px;\n\n    &:hover {\n      background: var(--m-background-subtle-primary-hovered, #f5f5f5);\n    }\n  }\n\n  &__right {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 6px;\n    border-radius: 999px;\n    background: var(--m-background-subtle-primary, #e3f2fd);\n    color: var(--m-primary, #007bff);\n  }\n\n  &__count {\n    font-size: 13px;\n    line-height: 1;\n    padding: 2px 8px;\n    border-radius: 999px;\n  }\n\n  &__arrow {\n    margin-left: 0;\n    color: currentColor;\n    flex-shrink: 0;\n  }\n}\n\n.ml-2 {\n  margin-left: 8px;\n}\n\n.d-block {\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .activities-header {\n    flex-direction: column;\n    align-items: stretch;\n\n    .search-container {\n      max-width: none;\n      min-width: 0;\n    }\n\n    .actions-container {\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
